import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { presentFormatedData } from '../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },

  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const PoDetails = (props) => {
  const classes = useStyles();

  const { POLineRecordDetails } = props;

  return (
    <React.Fragment>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            PO Details
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            PO / STO Number
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              POLineRecordDetails?.supplierPurchaseOrderNumber,
              'NA'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            PO Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {POLineRecordDetails?.supplierPODate
              ? presentFormatedData(
                  new Date(POLineRecordDetails?.supplierPODate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Sch Delivery Date
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {POLineRecordDetails?.scheduledDeliveryDate
              ? presentFormatedData(
                  new Date(POLineRecordDetails?.scheduledDeliveryDate)
                    .toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    })
                    .replace(/ /g, '-'),
                  'NA'
                )
              : 'NA'}
          </Typography>
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Material Type
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POLineRecordDetails?.materialType, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Material Name / Description
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POLineRecordDetails?.materialName, 'NA')}
          </Typography>
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            UOM
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              POLineRecordDetails?.unitOfMeasurementOrdered,
              'NA'
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Quantity
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POLineRecordDetails?.quantityOrdered, 'NA')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Delivery Tolerance
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(
              POLineRecordDetails?.overDeliveryTolerance,
              'NA'
            )}
          </Typography>
        </Grid>

        {/* Row 4 */}
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Shelf Life
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {POLineRecordDetails?.minShelfLife &&
            POLineRecordDetails?.shelfLifeUnitIndicator
              ? `${POLineRecordDetails?.minShelfLife} ${POLineRecordDetails?.shelfLifeUnitIndicator}`
              : 'NA'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Supplier Name
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(POLineRecordDetails?.supplierName, 'NA')}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default PoDetails;
